import { Http } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { LocalStorageModule } from 'angular-2-local-storage';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SlickModule } from 'ngx-slick';
import { SidebarModule } from 'ng-sidebar';

import { NavbarModule } from './modules/navbar';

import {
  UserService,
  PageService,
  ExpertiseService,
  BannerService,
  ScriptService,
  NetworkService,
  StrengthService,
  OfferService,
  ContactUsService,
  LocationService,
  JobService,
  MenuService,
  SearchService
} from '@shared/services';

import { ROUTES } from './web.routes';
import { NavbarComponent } from './components/navbar';
import { FooterComponent } from './components/footer';
import { UnderConstructionComponent } from './components/under-construction';
import { SidebarComponent } from './components/sidebar';
import { WebComponent } from './web.component';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http) {
  return new TranslateHttpLoader(http, './assets/web/i18n/', '.json');
}

@NgModule({
  declarations: [
    WebComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    RouterModule.forChild(ROUTES),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [
          Http
        ]
      }
    }),
    LocalStorageModule.withConfig({
      prefix: 'sge',
      storageType: 'localStorage'
    }),
    SlickModule.forRoot(),
    SidebarModule.forRoot(),
    NavbarModule
  ],
  providers: [
    UserService,
    PageService,
    BannerService,
    ExpertiseService,
    ScriptService,
    NetworkService,
    StrengthService,
    OfferService,
    ContactUsService,
    JobService,
    LocationService,
    MenuService,
    SearchService
  ]
})
export class WebModule {

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+web/web.module.ts